import { TReduxActions } from '../../../common/actions';
import { EFeaturesActionType } from '../../../common/actions/features/types';
import { TFeatureWithPrecision } from '../../../common/types/map';

export const defaultState: TFeatureWithPrecision | null = null;

export function activeFeatureReducer(
  state: TFeatureWithPrecision | null = defaultState,
  action: TReduxActions,
): TFeatureWithPrecision | null {
  switch (action.type) {
    case EFeaturesActionType.FeatureSelected:
      return action.payload;
  }

  return state;
}
